import classes from "./CbFooter.module.css";
import { communityBuddyLogo } from "../../../assets/constant";
const FooterLogo = () => {
    return (
        <div className={classes.container}>
            <div className={classes.logoWrapper}>
                <img src={communityBuddyLogo} className={classes.logo} alt="community buddy" title="community buddy" />
            </div>
        </div>
    );
};

export default FooterLogo;